import React, { useState, useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import flags from "../../coraWebComponents/utils/flags";

// proptypes
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";

// components
import ZiadostDetail from "../ziadosti/ZiadostDetail";
import Grid from '../../coraWebComponents/dataGrid/DataGrid';

// actions
import _ from "lodash";

const Ziadost = (props) => {
  const { className, cancel, moveNext, moveBack, ziadost } = props;

  const [selected, setSelected] = useState([]);

  const [data, setData] = useState([ziadost]);

  const page = useMemo(
    () => ({ skip: 0, take: data.length }),
    [data.length]
  );

  const expandChange = useCallback((event) => {
    const id = parseInt(_.keys(event.detailExpand)[0]);

    setData(prevData =>
      prevData.map(x =>
        x.I_AG_ZIADOST === id
          ? { ...x, expanded: !x.expanded }
          : x
      )
    );
  }, []);


  useEffect(() => {
    setData([ziadost]);
  }, [ziadost]);

  const genSchema = () => {
    return [
      {
        field: "KOD_ZIADOSTI",
        title: "Kód",
        width: "auto",
      },
      {
        field: "ADRESA_STAVBA",
        title: "Adresa",
        width: "auto",
      },
      {
        field: "ZIADATEL",
        title: "Žiadateľ",
        width: "auto",
      },
      {
        field: "N_STAV_ZIAD",
        title: "Stav",
        width: "auto",
      },
      {
        field: "D_POD",
        title: "Vytvorené",
        width: "auto",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
      },
      {
        field: "N_UZ_VYBAVUJE",
        title: "Vybavuje",
        width: "auto",
      },
      {
        field: "ZOSTAVA_DNI",
        title: "Zostáva dní",
        width: "auto",
        filter: "numeric",
      },
      {
        field: "D_VYBAVENIA",
        title: "Vybavené",
        width: "auto",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
      },
    ];
  };
  const schema = useMemo(() => genSchema(), []);

  const fixedFilter = useMemo(() => ({ filters: [] }), []);
  const filter = useMemo(() => ({ filters: [] }), []);
  const noop = useCallback(() => { }, []);
  const emptyArray = useMemo(() => [], []);

  const handleGridSelect = useCallback((selected) => {
    setSelected(selected);
  }, []);

  return (
    <div className={`row m-0 ${className}`}>
      <div className="col p-0">
        <Grid
          data={data}
          isLoading={false}
          onChange={noop}
          onGet={noop}
          onGetList={noop}
          selected={selected}
          onSelect={handleGridSelect}
          onExpandChange={expandChange}
          primaryField="I_AG_ZIADOST"
          schema={schema}
          detailSchema={emptyArray}
          total={data.length}
          detail={ZiadostDetail}
          disabled={flags.PAGING | flags.FILTER | flags.SORT}
          allColumns
          fixedFilter={fixedFilter}
          initSort={emptyArray}
          onChangeField={noop}
          onCancel={noop}
          updateSort={noop}
          filter={filter}
          sort={emptyArray}
          page={page}
          hidden={flags.ADD | flags.COPY | flags.CANCEL | flags.PRINT | flags.RESET | flags.TOOLBAR |
            flags.EDIT | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.EDITALL | flags.GRID_CELL_EDIT | flags.USER_FILTER | flags.DETAIL}
          hiddenBack
        />
        {/* BUTTONS */}
        <div className="k-form-field flexGroup">
          <Button primary label="Zrusiť" onClick={cancel} />
          <div className="flexGroup">
            <Button primary label="Späť" onClick={moveBack} />
            <Button primary label="Ďalej" onClick={moveNext} />
          </div>
        </div>
      </div>
    </div>
  );

}

const mapStateToProps = (state) => {
  return {
    ziadost: state.ziadost.data,
  };
};

const mapDispatchToProps = (dispatch) => ({});

Ziadost.propTypes = {
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  ziadost: ziadostPropTypes.ziadost,
  className: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Ziadost)
);
